import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface UserSearchProps {
  isHover?: boolean;
  color?: string;
  style?: React.CSSProperties;
}

export default function UserSearchIcon({ isHover = false, color, style = {}, ...props }: UserSearchProps) {
  const iconColor = isHover ? RoutalPalette.primary20 : RoutalPalette.primary80;

  return (
    <SvgIcon {...props} viewBox="0 0 24 24" style={{ width: `24px`, height: `24px`, fill: `transparent`, ...style }}>
      <g>
        <path
          d="M1.01074 2.93469H4.82892"
          stroke={color ? color : iconColor}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.91992 1.02563L4.82901 2.93473L2.91992 4.84382"
          stroke={color ? color : iconColor}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path
        d="M18.0118 0.75293C17.2559 0.755009 16.5094 0.921349 15.8241 1.24044C15.1388 1.55952 14.531 2.02373 14.0428 2.60093C13.1365 2.3466 12.2002 2.21443 11.2588 2.20793C8.47 2.2111 5.79624 3.32017 3.82394 5.29191C1.85164 7.26364 0.741815 9.93708 0.737846 12.7259C0.733457 14.1084 1.00368 15.4779 1.53283 16.7551C2.06199 18.0323 2.83953 19.1917 3.82035 20.1659C4.79491 21.1458 5.95416 21.9227 7.23098 22.4515C8.5078 22.9804 9.87684 23.2507 11.2588 23.2469C14.0481 23.2438 16.7221 22.1342 18.6943 20.1618C20.6664 18.1894 21.7756 15.5152 21.7783 12.7259C21.7783 11.7929 21.6268 10.8824 21.3868 9.99293C21.9715 9.50491 22.4423 8.89486 22.7662 8.20559C23.0901 7.51631 23.2593 6.76451 23.2618 6.00293C23.2618 3.10793 20.9068 0.75293 18.0118 0.75293ZM18.0118 2.25293C20.0803 2.25293 21.7618 3.93443 21.7618 6.00293C21.7618 8.07143 20.0803 9.75293 18.0118 9.75293C17.0175 9.75214 16.0642 9.35679 15.3611 8.6537C14.658 7.95061 14.2626 6.99725 14.2618 6.00293C14.2618 3.93443 15.9418 2.25293 18.0118 2.25293ZM11.2048 9.73493C12.8518 9.73493 14.1883 11.0729 14.1883 12.7529C14.1864 13.5256 13.8843 14.2673 13.3458 14.8214C12.8074 15.3756 12.0746 15.6988 11.3023 15.7229C11.2588 15.7229 11.2168 15.7184 11.1733 15.7184C11.1358 15.7184 11.1028 15.7214 11.0653 15.7229C10.2894 15.6941 9.55518 15.3644 9.01816 14.8035C8.48114 14.2427 8.18352 13.4949 8.18835 12.7184C8.18835 11.0729 9.52485 9.73493 11.2048 9.73493ZM11.0653 17.2229C11.1013 17.2229 11.1343 17.2349 11.1703 17.2349H11.2063C11.2393 17.2349 11.2663 17.2244 11.2993 17.2229C12.3458 17.2412 13.3759 17.4855 14.3191 17.9391C15.2623 18.3927 16.0963 19.0449 16.7638 19.8509C15.1899 21.0777 13.2514 21.7439 11.2558 21.7439C9.21694 21.7481 7.23774 21.0559 5.64585 19.7819C6.31536 18.9946 7.14505 18.3592 8.07959 17.9179C9.01412 17.4766 10.032 17.2397 11.0653 17.2229Z"
        fill={color ? color : iconColor}
      />
    </SvgIcon>
  );
}
